(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["module", "exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports);
    global.zhCN = mod.exports;
  }
})(this, function (module, exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    "rich": {
      "validator": {
        "type": {
          "array": "数据类型应为数组",
          "url": "请输入有效网址",
          "date": "请选择有效日期",
          "email": "请输入有效邮箱",
          "string": "请输入字符",
          "tel": "请输入有效的手机号码",
          "number": "请输入数字"
        },
        "max": {
          "tel": "请勿超过 {{config}} 位字符",
          "number": "请勿大于 {{config}}",
          "email": "请勿超过 {{config}} 位字符",
          "url": "请勿超过 {{config}} 位字符",
          "date": "请选择 {{config | toLocaleDateString(\"yyyy年MM月dd日\")}} 之前的时间",
          "array": "最多选择 {{config}} 项",
          "string": "请勿超过 {{config}} 位字符"
        },
        "min": {
          "string": "至少输入 {{config}} 位字符",
          "array": "请选择至少 {{config}} 项",
          "email": "至少输入 {{config}} 位字符",
          "tel": "至少输入 {{config}} 位字符",
          "number": "不得小于 {{config}}",
          "date": "请选择 {{config | toLocaleDateString(\"yyyy年MM月dd日\")}} 之后的时间",
          "url": "至少输入 {{config}} 位字符"
        },
        "len": {
          "string": "请输入 {{config}} 位字符",
          "number": "长度应等于 {{config}}",
          "array": "请选择 {{config}} 项",
          "tel": "请输入 {{config}} 位字符",
          "date": "请选择 {{config | toLocaleDateString(\"yyyy年MM月dd日\")}} 之前的时间",
          "email": "请输入 {{config}} 位字符",
          "url": "请输入 {{config}} 位字符"
        },
        "notWhitespace": "空白内容无效",
        "custom": "未通过校验",
        "pattern": "格式错误",
        "required": "此为必填项"
      },
      "timePicker": {
        "minutes": "分",
        "hours": "点",
        "today": "今日",
        "formatDate": "M月D日",
        "selectTime": "选择时间",
        "now": "现在"
      },
      "textArea": {
        "placeholder": "请输入..."
      },
      "resultPage": {
        "networkSubtext": "点击重新加载",
        "emptyText": "暂无信息",
        "networkText": "网络连接异常",
        "lostText": "您要访问的页面已丢失"
      },
      "common": {
        "selectText": "请选择",
        "ok": "确定",
        "cancel": "取消",
        "confirm": "确认"
      },
      "segmentPicker": {
        "next": "下一步",
        "prev": "上一步"
      }
    }
  };
  module.exports = exports["default"];
});